import Image from "next/image";
import { Heading } from "../design-system/atoms/Heading";
import { BlockProps } from "./blocks/registry";
import Link from "next/link";
import { resolveLegacyLink } from "../utils/linkUtils";
import { useEffect, useState } from "react";
import { buildProspectLink } from "../utils/prospectLink";

export default function OffrirBloc({ data }: BlockProps) {
  if (!data) return null;
  const [commanderHref, setCommanderHref] = useState<string>(
    resolveLegacyLink("/parcours-prospects", "clients")
  );

  useEffect(() => {
    const link =
      buildProspectLink() || resolveLegacyLink("/parcours-prospects", "clients");
    setCommanderHref(link);
  }, []);

  return (
    <section className="py-16 bg-white px-6">
      {/* Titre */}
      <Heading
        as="h2"
        className="text-4xl lg:text-5xl text-center font-bold text-text mb-12"
      >
        {data.titre}
      </Heading>

      {/* Cartes */}
      <div className="grid gap-8 lg:grid-cols-3 max-w-6xl mx-auto pt-12">
        {data.offre.map((card, index) => (
          <article
            key={index}
            className="bg-white rounded-2xl shadow-md overflow-hidden flex flex-col"
          >
            <div className="relative w-full h-[320px] md:h-[420px] lg:h-[260px]">
              <Image
                src={card.icon.url}
                alt={card.titre}
                fill
                sizes="(max-width: 1024px) 100vw, 33vw"
                className="object-cover"
              />
            </div>
            <div className="p-6 flex-1 flex flex-col">
              <h3 className="text-xl font-semibold text-secondary mb-2">
                {card.titre}
              </h3>
              <p className="text-gray-700 flex-1">{card.descr}</p>
            </div>
          </article>
        ))}
      </div>

      {/* Bouton */}
      <div className="flex justify-center mt-12">
        <Link target="_blank" href={commanderHref}>
          <button className="bg-secondary text-white px-8 py-3 rounded-md font-semibold hover:bg-primaryGreen transition">
            {data.cta.text}
          </button>
        </Link>
      </div>
    </section>
  );
}
